import { HelpCircle, Shield, LifeBuoy, MessageSquare, Grid, User } from "react-feather";

export default [
  {
    id: "configurations",
    title: "Configurations",
    children: [
      {
        id: "company-settings",
        title: "Company",
        icon: <Grid size={20} />,
        navLink: "/app/company-settings",
      },
      {
        id: "user-settings",
        title: "User",
        icon: <User size={20} />,
        navLink: "/app/user-settings",
      },
    ],
  },
  {
    id: "others",
    title: "Others",
    children: [
      {
        id: "live-chat",
        title: "Live Chat",
        icon: <MessageSquare size={20} />,
        navLink: "/app/livechat",
      },
      {
        id: "external-user-guide",
        title: "User Guide",
        icon: <HelpCircle size={20} />,
        externalLink: true,
        newTab: true,
        navLink: "https://vitaverify.notion.site/Vita-Analytics-Guide-0ca2f385552043ce9bfab23f2fcc365a",
      },
      {
        id: "external-privacy-policy",
        title: "Privacy Policy",
        icon: <Shield size={20} />,
        externalLink: true,
        newTab: true,
        navLink: "https://vita-privacy-policy.s3-ap-southeast-1.amazonaws.com/Vita+Privacy+Policy.pdf",
      },
      {
        id: "external-feedback",
        title: "Feedback",
        icon: <LifeBuoy size={20} />,
        externalLink: true,
        newTab: true,
        navLink: "https://docs.google.com/forms/d/e/1FAIpQLSe6iVzNtPKjq9YLYUsTL9gbklb3srT98RSxUDbwg9iu7q9Zxw/viewform?usp=sf_link",
      },
    ],
  },
];
